import { gql } from '@apollo/client';

export const DELETE_QUESTION = gql(/*GraphQL*/ `
   mutation DeleteQuestion($id: ID!) {
  deleteQuestion(id: $id)
}`);
